<template>
  <v-app translate="no" class="notranslate">
    <Navbar />
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
import Navbar from './components/Navbar';

export default {
  name: "App",

  components: {
    Navbar
  },

  data: () => ({
    //
  })
};
</script>

<style lang="scss">
    @import "assets/sass/styles";
</style>

